<div class="wrapper">
    <nav class="main-header navbar navbar-expand border-bottom navbar-dark bg-info">
        <div id="sideBar" class="sidebar sidebar-width ">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link button-left" data-widget="pushmenu" href="#"><i class="fa fa-bars bar hover-me"></i></a>
                </li>
            </ul>
        </div>

        <ul class="navbar-nav ml-auto">

            <!-- <li class="nav-item dropdown"> -->
            <!-- <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false"> -->
            <!-- <i class="fa fa-comments-o fa-lg"></i> -->
            <!-- <span *ngIf="unreadMessageCount" class="badge badge-danger navbar-badge">{{ unreadMessageCount }}</span> -->
            <!-- </a> -->
            <!-- <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right comment-menu"> -->
            <!-- <a *ngFor="let msg of messages" href="javascript:void(0)" class="dropdown-item request-message"
                    [class.request-message]="msg.type === 'request'"
                    [class.request-update-message]="msg.type === 'request_update'"> -->
            <!-- <div class="media"> -->
            <!-- <ng-container *ngIf="msg.type === 'request'">
                            <img src="{{msg.folderPath+msg.senderImage}}" alt="User Avatar"
                                class="img-size-50 mr-3 img-circle">
                            <div class="media-body msg-body" (click)="confirmPopupModal(modelTemplate, msg)">
                                <h3 class="dropdown-item-title">
                                    {{ msg.sender_name }}
                                    <span class="float-right text-sm text-danger">
                                        <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                                    </span>
                                </h3>
                                <p class="text-sm msg-text">{{ msg.message }}</p>
                                <p class="text-sm text-muted">
                                    <i class="fa fa-clock-o mr-1"></i> {{ msg.created_at | niceDateFormat }}
                                </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="msg.type === 'request_update'">
                            <img src="{{msg.folderPath+msg.receiverImage}}" alt="User Avatar"
                                class="img-size-50 mr-3 img-circle">
                            <div class="media-body msg-body"
                                (click)="confirmPopupModal(requestNotificationModal, msg); updateRequestNotificationStatus(msg)">
                                <h3 class="dropdown-item-title">
                                    {{ msg.status == 1 ? 'Accepted' : 'Declined' }}
                                    <span class="float-right text-sm text-danger">
                                        <i class="fa fa-check-square-o" aria-hidden="true"></i>
                                    </span>
                                </h3>
                                <p class="text-sm msg-text">
                                    {{ msg.receiver_name }} has {{ msg.status == 1 ? 'accepted' : 'declined' }} your
                                    adjust request
                                </p>
                                <p class="text-sm text-muted">
                                    <i class="fa fa-clock-o mr-1"></i> {{ msg.updated_at | niceDateFormat }}
                                </p>
                            </div>
                        </ng-container> -->

            <!-- </div> -->
            <!-- </a> -->
            <!-- </div>
        </li> -->

            <!-- <li class="nav-item dropdown">
            <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false">
                <i class="fa fa-bell-o fa-lg"></i> -->
            <!-- <span *ngIf="unreadNotificatons" class="badge badge-danger navbar-badge">{{ unreadNotificatons }}</span> -->
            <!-- </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right comment-menu"> -->
            <!-- <ng-container *ngFor="let msg of notifications">
                    <ng-container *ngIf="msg.title == 'comment' || msg.title == 'commission Change'">
                        <a (click)="updateNotificationStatus(msg.deal_id)" [routerLink]="['/deals/getDeal']"
                            [queryParams]="{dealID:msg.deal_id}" href="javascript:void(0)" target="_blank"
                            class="dropdown-item">
                            <div class="media">
                                <img src="{{msg.folderPath+msg.senderImage}}" alt="User Avatar"
                                    class="img-size-50 mr-3 img-circle">
                                <div class="media-body msg-body">
                                    <h3 class="dropdown-item-title">
                                        {{ msg.title | titlecase }}
                                        <span class="float-right text-sm text-primary">
                                            {{ msg.msgCount }}
                                        </span>
                                    </h3>
                                    <p class="text-sm msg-text">{{ msg.comment }}</p>
                                    <p class="text-sm text-muted">
                                        <i class="fa fa-clock-o mr-1"></i> {{ msg.created_at | niceDateFormat }}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </ng-container>
                    <ng-container *ngIf="msg.title == 'tag'">
                        <a (click)="updateBuyerNotificationStatus(msg.stock,msg.user_id)"
                            [routerLink]="['/vehicles/view']" [queryParams]="{stock:msg.stock}"
                            href="javascript:void(0)" target="_blank" class="dropdown-item">
                            <div class="media">
                                <img src="{{msg.folderPath+msg.senderImage}}" alt="User Avatar"
                                    class="img-size-50 mr-3 img-circle">
                                <div class="media-body msg-body">
                                    <h3 class="dropdown-item-title">
                                        {{msg.title | titlecase}}
                                        <span class="float-right text-sm text-primary">
                                            <i class="fa fa-tag"></i>
                                        </span>
                                    </h3>
                                    <p class="text-sm msg-text">{{msg.comment}}</p>
                                    <p class="text-sm text-muted"><i class="fa fa-clock-o mr-1"></i> {{msg.created_at |
                                        niceDateFormat}}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </ng-container>
                </ng-container> -->
            <!-- </div>
        </li> -->

            <li class="nav-item dropdown select-user">
                <a class="nav-link" data-toggle="dropdown" href="#">
                    <i class="fa fa-user-circle-o "></i>
                    <div class="name">
                        <p>{{userName | titlecase}}</p>
                        <!-- <span class="">{{ role }}</span> -->
                    </div>
                </a>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right dropdown-options">
                    <!-- <a href="#" routerLink="/settings" class="dropdown-item">
                        <i class="fa fa-cogs mr-2"></i> General Settings
                    </a> -->
                    <!-- <a href="javascript:void(0)" (click)="openModal(template)" class="dropdown-item">
                    <i class="fa fa-key mr-2"></i> Change Password
                </a> -->
                    <!-- <div class="dropdown-divider"></div>
                    <a href="#" routerLink="/users/profile" class="dropdown-item">
                        <i class="fa fa-user mr-2"></i> Edit Profile
                    </a> -->
                    <!-- <div class="dropdown-divider"></div> -->
                    <a href="javascript:void(0)" (click)="logout()" class="dropdown-item">
                        <i class="fa fa-power-off mr-2"></i> Log Out
                    </a>
                </div>
            </li>
        </ul>
    </nav>



    <!-- <div class="main">
    <div class="sidebar-width">
        <aside>
            <div class="sidebar left ">
                <app-admin-sidebar></app-admin-sidebar>
            </div>
        </aside>
    </div>
    <div class="main-width">
        <router-outlet></router-outlet>
    </div>
</div> -->

    <app-admin-sidebar></app-admin-sidebar>
    <div class="content-wrapper admin-dashwrapper" style="min-height: 226px;background-color: #fff;;">
        <!-- <div style="position: relative"> -->

            <!-- <ngx-ui-loader [loaderId]="'loader-01'"></ngx-ui-loader> -->
        <!-- </div> -->
        <router-outlet></router-outlet>
    </div>
</div>